// extracted by mini-css-extract-plugin
export default {"container":"style_container__y6g3X","title":"style_title__9y6mF","subtitle":"style_subtitle__-WJNV","error":"style_error__NOc0Q"};